module.exports = __webpack_public_path__ + "static/media/view-data-hover.467dbb6f.svg";